<ds-notify></ds-notify>

<app-menu *ngIf="isValidToken" [ngClass]="showComponent ? '':'d-none'"></app-menu>
<router-outlet></router-outlet>
<app-footer *ngIf="isValidToken" [ngClass]="showComponent ? '':'d-none'"></app-footer>

<ngx-spinner bdOpacity="0.8" type="ball-scale-multiple" size="medium" [fullScreen]="true"
  template="<img src='/assets/images/icons8-pullups.gif' />">
  <p style="font-size: 20px; color: white">{{ '@direction.common.loading' | translate }}</p>
</ngx-spinner>